import React from 'react';
import './Style.css';

const Home = () => {
    return (
      <div>
        {/* Hero Section */}
        <section className="hero-homeowner-section d-flex align-items-center text-center">
          <div className="container"></div>
        </section>
      </div>
    );
  };

export default Home;
